import { apiPrivateService } from "api/api";

const FILE_UPLOAD_FIELD_KEY = "file";

async function uploadSingleFile(file: File): Promise<number> {
  const formData = new FormData();
  formData.append(FILE_UPLOAD_FIELD_KEY, file);

  console.log("[uploadSingleFile] uploading:", file.name, file.size);

  try {
    const response = await apiPrivateService.post(
      "/v2/international-payment-files/upload",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    console.log("[uploadSingleFile] response:", response.data);
    return (response.data.data?.id ?? response.data.id) as number;
  } catch (err) {
    console.error("[uploadSingleFile] ERROR:", err);
    throw err;
  }
}

export async function uploadAllFiles(
  data: any,
): Promise<Record<string, number[]>> {
  const uploadedMap: Record<string, number[]> = {};

  const fileFieldEntries = Object.entries(data).filter(([key, value]) => {
    console.log(
      `[uploadAllFiles] checking key: ${key}, type: ${typeof value}, isFileList: ${value instanceof FileList}, length: ${(value as any)?.length}`,
    );
    return (
      key.startsWith("upload_field_") &&
      value instanceof FileList &&
      (value as FileList).length > 0
    );
  });
  console.log(
    "[uploadAllFiles] fileFieldEntries found:",
    fileFieldEntries.length,
  );

  if (fileFieldEntries.length === 0) return uploadedMap;

  await Promise.all(
    fileFieldEntries.map(async ([key, fileList]) => {
      const files = Array.from(fileList as FileList);
      const ids = await Promise.all(files.map(uploadSingleFile));
      uploadedMap[key] = ids;
    }),
  );

  return uploadedMap;
}

export function buildFormData(
  data: any,
  uploadedMap: Record<string, number[]> = {},
): FormData {
  const formData = new FormData();

  Object.entries(data ?? {}).forEach(([key, value]) => {
    if (
      key.startsWith("upload_field_") &&
      Array.isArray(value) &&
      (value as any[]).every((v) => typeof v === "number")
    ) {
      const fieldId = key.replace("upload_field_", "");
      (value as number[]).forEach((id) =>
        formData.append(
          `payment_card_type_upload_${fieldId}_file_ids[]`,
          String(id),
        ),
      );
      return;
    }

    if (key.startsWith("upload_field_") && value instanceof FileList) {
      console.warn(
        `[buildFormData] FileList найден в ${key} — файлы не были загружены заранее`,
      );
      return;
    }

    if (key.startsWith("card_type_file_ids_")) return;

    if (key.startsWith("payment_card_type_upload_") && key.endsWith("_reuse")) {
      formData.append(key, String(value));
      return;
    }

    if (key === "reuse_from_payment_id") {
      formData.append(key, String(value));
      return;
    }

    if (key === "previousPaymentData") return;

    if (value === null || value === undefined) return;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item instanceof File) {
          formData.append(`${key}[]`, item);
        } else {
          formData.append(`${key}[]`, String(item ?? ""));
        }
      });
      return;
    }

    if (value instanceof File) {
      formData.append(key, value);
      return;
    }

    formData.append(key, String(value));
  });

  return formData;
}
